// src/components/Architecture.js
import React from "react";

const layers = [
  { num: "01", title: "Data Sources", desc: "APIs, databases, SaaS systems, IoT streams, and third-party integrations." },
  { num: "02", title: "Data Ingestion", desc: "Reliable batch and real-time streaming pipelines built with Apache Kafka and ADF." },
  { num: "03", title: "Data Processing", desc: "Distributed compute engines using Apache Spark and Azure Databricks." },
  { num: "04", title: "Data Storage", desc: "Scalable data lakes, cloud warehouses, and Delta Lake architecture." },
  { num: "05", title: "Analytics & BI", desc: "Dashboards, reports, and insights powered by Power BI and custom visualizations." },
  { num: "06", title: "Web & App Layer", desc: "React frontends, REST APIs, and mobile apps delivering seamless user experiences." },
];

function Architecture() {
  return (
    <section className="architecture" id="insights">
      <div className="section-inner">

        <div className="section-header" style={{textAlign:"center"}}>
          <div className="section-tag" style={{margin:"0 auto 20px"}}>
            <i className="fas fa-layer-group"></i> Technology Architecture
          </div>
          <h2 className="section-title">Our Technology Stack &amp; Architecture</h2>
          <p className="section-subtitle" style={{margin:"0 auto"}}>
            Scalable, resilient, and modern data and web infrastructure designed to power your business at any scale.
          </p>
        </div>

        <div className="arch-grid">
          {layers.map((l, i) => (
            <div className="arch-card" key={i}>
              <div className="arch-step-num">{l.num}</div>
              <div>
                <h3>{l.title}</h3>
                <p>{l.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Architecture;
